/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Resources_TitleInputs */

const en_directory_footer_resources_title = /** @type {(inputs: Directory_Footer_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const zh_directory_footer_resources_title = /** @type {(inputs: Directory_Footer_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Directory_Footer_Resources_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_resources_title = /** @type {((inputs?: Directory_Footer_Resources_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Resources_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_resources_title(inputs)
	return zh_directory_footer_resources_title(inputs)
});
export { directory_footer_resources_title as "directory.footer.resources_title" }